import { connect } from 'react-redux';
import { compose } from 'redux';
import withUserData from 'hoc/withUserData';
import { checkLogin } from 'ducks/auth';
import Login from './Login';

const mapStatetoProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = {
  checkLogin,
};

export default compose(
  connect(mapStatetoProps, mapDispatchToProps),
  withUserData
)(Login);
